var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPassword(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#F6F0FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.3811 9.58479C14.0757 8.89021 15.0177 8.5 16 8.5C16.9823 8.5 17.9243 8.89021 18.6189 9.58479C19.3135 10.2794 19.7037 11.2214 19.7037 12.2037V14.4259H20.4445C21.0338 14.4259 21.5991 14.6601 22.0158 15.0768C22.4326 15.4935 22.6667 16.0588 22.6667 16.6481V21.0926C22.6667 21.682 22.4326 22.2472 22.0158 22.6639C21.5991 23.0807 21.0338 23.3148 20.4445 23.3148H11.5556C10.9662 23.3148 10.401 23.0807 9.98422 22.6639C9.56747 22.2472 9.33334 21.682 9.33334 21.0926V16.6481C9.33334 16.0588 9.56747 15.4935 9.98422 15.0768C10.401 14.6601 10.9662 14.4259 11.5556 14.4259H12.2963V12.2037C12.2963 11.2214 12.6865 10.2794 13.3811 9.58479ZM13.7778 14.4259H18.2222V12.2037C18.2222 11.6143 17.9881 11.0491 17.5714 10.6324C17.1546 10.2156 16.5894 9.98148 16 9.98148C15.4106 9.98148 14.8454 10.2156 14.4287 10.6324C14.0119 11.0491 13.7778 11.6143 13.7778 12.2037V14.4259ZM11.5556 15.9074C11.3591 15.9074 11.1707 15.9855 11.0318 16.1244C10.8929 16.2633 10.8148 16.4517 10.8148 16.6481V21.0926C10.8148 21.2891 10.8929 21.4775 11.0318 21.6164C11.1707 21.7553 11.3591 21.8333 11.5556 21.8333H20.4445C20.6409 21.8333 20.8293 21.7553 20.9682 21.6164C21.1072 21.4775 21.1852 21.289 21.1852 21.0926V16.6481C21.1852 16.4517 21.1072 16.2633 20.9682 16.1244C20.8293 15.9855 20.6409 15.9074 20.4445 15.9074H11.5556ZM16 17.3889C16.4091 17.3889 16.7408 17.7205 16.7408 18.1296V19.6111C16.7408 20.0202 16.4091 20.3519 16 20.3519C15.5909 20.3519 15.2593 20.0202 15.2593 19.6111V18.1296C15.2593 17.7205 15.5909 17.3889 16 17.3889Z",
    fill: "#7956D8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPassword);
export default __webpack_public_path__ + "static/media/password.5070e936f7027309cef946868d13f568.svg";
export { ForwardRef as ReactComponent };